import { DomesticAirLines } from 'shared/constants'

import { DifficultRoute } from '../models/find-ticket/models'

const localFlightInfants = 5

const abroadFlightInfants = 2

export const checkCityIataCodes = (
  searchList?: DifficultRoute[],
): { age: number; isLocalFlight: boolean } => {
  if (!searchList?.[0]?.from)
    return { age: localFlightInfants, isLocalFlight: true }

  const isLocalFlight = searchList.every(
    (item) =>
      DomesticAirLines.includes(item?.from?.cityIataCode || '') &&
      DomesticAirLines.includes(item?.to?.cityIataCode || ''),
  )

  return isLocalFlight
    ? { age: localFlightInfants, isLocalFlight }
    : { age: abroadFlightInfants, isLocalFlight }
}
